import { EnvelopeIcon, PhoneIcon } from "@heroicons/react/24/outline";
import Button from "common/components/Button/Button";
import { Link } from "react-router-dom";
import { User } from "types";
import useAuth from "common/hooks/useAuth";
import { useTranslation } from "react-i18next";
import Status from "common/components/Status/Status";
import TooltipWrapper from "common/components/TooltipWrapper/TooltipWrapper";

function UserItem({ item, onDelete, onNavigate }: any) {
  const { t } = useTranslation();
  const { user: currentUser } = useAuth();
  const canSeeDetailsFromItem =
    (currentUser?.isSuperadmin ||
      (currentUser?.isAdmin &&
        Boolean(currentUser?.park.id === item.park.id)) ||
      ((currentUser?.isManager || currentUser?.isObserver) &&
        Boolean(currentUser?.park.id === item.park.id) &&
        currentUser?.administrationPermissions?.user?.read)) ??
    false;
  const canEditItem =
    (currentUser?.isSuperadmin ||
      (currentUser?.isAdmin &&
        Boolean(currentUser?.park.id === item.park.id)) ||
      ((currentUser?.isManager || currentUser?.isObserver) &&
        Boolean(currentUser?.park.id === item.park.id) &&
        currentUser?.administrationPermissions?.user?.update &&
        ["Manager", "Observer"].includes(item?.role?.name))) ??
    false;
  const canDeleteItem =
    (currentUser?.isSuperadmin ||
      (currentUser?.isAdmin &&
        Boolean(currentUser?.park.id === item.park.id)) ||
      ((currentUser?.isManager || currentUser?.isObserver) &&
        Boolean(currentUser?.park.id === item.park.id) &&
        currentUser?.administrationPermissions?.user?.delete &&
        ["Observer"].includes(item?.role?.name))) ??
    false;

  const { courriel, phoneNumber, role, username } = item as User;

  const editLink =
    currentUser?.id === item?.id ? "/my-account" : `/users/edit/${item.id}`;

  return (
    <div className="responsive-flex-lg px-4 py-4 mt-2 w-full relative bg-white cursor-pointer rounded-lg border border-slate-150 transition-all">
      <Link
        to={editLink}
        className={
          !canSeeDetailsFromItem
            ? "pointer-events-none responsive-flex-lg flex-1"
            : "responsive-flex-lg flex-1"
        }
      >
        {/* {role?.name !== "Authenticated" && (
          <div className="flex relative w-40 h-40 lg:w-16 lg:h-16 shrink-0">
            <div className="absolute -top-2 -left-2">
              <WorkSiteIcon iconStyle={iconStyle} />
            </div>
            { <div className="rounded-lg overflow-hidden w-full">
              <ImageComponent
                image={avatar ? ImageFromStrapiMedia(avatar)?.uri : undefined}
              />
            </div>}
          </div>
        )} */}
        <div className="flex flex-col flex-1 justify-between lg:pl-4 lg:pr-6">
          <div className="flex gap-3">
            <div className="flex-1 flex flex-col gap-2 py-3 lg:py-0">
              <h4 className="text-xl font-bold text-primary leading-4 mb-1">
                {username}
              </h4>

              {courriel && (
                <div className="flex items-center gap-1 text-sm">
                  <EnvelopeIcon className="w-3 h-3" />
                  <span className="font-bold">{courriel}</span>
                </div>
              )}

              {phoneNumber && (
                <div className="flex items-center gap-1 text-sm">
                  <PhoneIcon className="w-3 h-3" />
                  <span className="font-bold">{phoneNumber}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </Link>

      <div className="flex flex-col justify-between items-end text-xs lg:border-l pl-4 min-w-[22em] border-slate-150 gap-2">
        <div className={role ? "flex justify-end gap-2" : ""}>
          {role && <Status status={role?.name} />}
          <Status status={item.confirmed ? "confirmed" : "unconfirmed"} />
        </div>

        <div className="flex w-full items-center justify-end text-slate-500">
          <div>
            <div className="flex w-full gap-1">
              <TooltipWrapper content={<span>{t("actions.delete")}</span>}>
                <Button
                  type="error-line"
                  icon="TrashIcon"
                  compact
                  onClick={() => onDelete(item.id)}
                  disabled={!canDeleteItem}
                  confirmMessage={t("actions.confirmDelete")}
                />
              </TooltipWrapper>

              <Button
                title={t("actions.edit")}
                type="warning-line"
                icon="PencilSquareIcon"
                onClick={() => onNavigate(item.id)}
                disabled={!canEditItem}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserItem;
